(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"] && !window.DesignMode) return;
  try {
    
document.addEventListener('change', function(e){
  var sel = e.target.closest('select[id^="ProductSelect-"]');
  if(!sel) return;
  var option = sel.options[sel.selectedIndex];
  var priceEl = document.getElementById('ProductPrice-{{ section.id }}');
  if(priceEl && option && option.text){
    // Prix déjà affiché par Liquid à l'ouverture; pas de recalcul dynamique ici
  }
});

  } catch(e) { console.error(e); }
})();
})();
